<template>
  <div :class="{ 'is-editable': true }">
    <vue-file-toolbar-menu :content="menu" class="bar" />
    <div class="document-editor">
      <vue-document-editor
        class="editor"
        ref="editor"
        :content="content"
        :overlay="overlay"
        :zoom="zoom"
        :page_format_mm="page_format_mm"
        :page_margins="page_margins"
        :display="display"
        :editable="true"
        @changeDataContent="changeDataContent"
      />
    </div>

    <div class="button-group mt-2">
      <div>
        <el-button type="info" plain @click="onCancelForm">Hủy</el-button>
      </div>
      <div>
        <el-button type="primary" @click="onCompleteDraf">Kết xuất văn bản</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import MethodService from '../../../service/MethodService'
import DraffDocumentAutoModel from '../DocumentDrafting/Composer/DraffDocumentAutoModel'
import DdaTemplateApi from '@/moduleApi/DdaTemplateApi'
import DdaCategoryApi from '@/moduleApi/DdaCategoryApi'
import DraffDocumentAutoApi from '@/moduleApi/DraffDocumentAutoApi'
import EmployeeSignatureApi from '@/moduleApi/EmployeeSignatureApi'
import VueDocumentEditor from '@/component/VueDocumentEditor/DocumentEditor'
import VueFileToolbarMenu from 'vue-file-toolbar-menu'
import toastr from 'toastr'

const STORAGE_KEY = 'dataFormElectronicDocument'

export default {
  components: { VueDocumentEditor, VueFileToolbarMenu },
  data() {
    return {
      innerHeight: window.innerHeight - 150,
      dataForm: MethodService.copyObject(DraffDocumentAutoModel.dataForm),
      content: [],
      contentChange: [],
      dataDefault: {
        listTemplates: [],
        listCategories: [],
      },
      zoom: 1.25,
      zoom_min: 0.6,
      zoom_max: 2.3,
      page_format_mm: [210, 297],
      page_margins: '10mm 15mm',
      display: 'grid',
      mounted: false,
      undo_count: -1,
      content_history: [],
      currentUser: MethodService.getCurrentUser(),
    }
  },
  created() {
    let data = localStorage.getItem(STORAGE_KEY)
    if (data) {
      this.dataForm = JSON.parse(data)
      this.content = [this.dataForm.html ? MethodService.decodeHTML(this.dataForm.html) : '']
    }

    let start_zoom_gesture = false
    let start_dist_touch = false
    let start_zoom_touch = false

    window.addEventListener('wheel', (e) => {
      if (e.ctrlKey) {
        e.preventDefault()
        this.zoom = Math.min(Math.max(this.zoom - e.deltaY * 0.01, this.zoom_min), this.zoom_max)
      }
    }, { passive: false })

    window.addEventListener('gesturestart', (e) => {
      e.preventDefault()
      start_zoom_gesture = this.zoom
    })
    window.addEventListener('gesturechange', (e) => {
      e.preventDefault()
      if (!start_zoom_touch) {
        this.zoom = Math.min(Math.max(start_zoom_gesture * e.scale, this.zoom_min), this.zoom_max)
      }
    })
    window.addEventListener('gestureend', () => { start_zoom_gesture = false })

    window.addEventListener('touchstart', (e) => {
      if (e.touches.length == 2) {
        e.preventDefault()
        start_dist_touch = Math.hypot(
          e.touches[0].pageX - e.touches[1].pageX,
          e.touches[0].pageY - e.touches[1].pageY
        )
        start_zoom_touch = this.zoom
      }
    }, { passive: false })
    window.addEventListener('touchmove', (e) => {
      if (start_dist_touch && start_zoom_touch) {
        e.preventDefault()
        let zoom = start_zoom_touch * Math.hypot(
          e.touches[0].pageX - e.touches[1].pageX,
          e.touches[0].pageY - e.touches[1].pageY
        ) / start_dist_touch
        this.zoom = Math.min(Math.max(zoom, this.zoom_min), this.zoom_max)
      }
    }, { passive: false })
    window.addEventListener('touchend', () => {
      start_dist_touch = false
      start_zoom_touch = false
    }, { passive: false })

    const manage_undo_redo = (e) => {
      switch (e && e.inputType) {
        case 'historyUndo': e.preventDefault(); e.stopPropagation(); this.undo(); break
        case 'historyRedo': e.preventDefault(); e.stopPropagation(); this.redo(); break
      }
    }
    window.addEventListener('beforeinput', manage_undo_redo)
    window.addEventListener('input', manage_undo_redo)
  },
  mounted() {
    this.mounted = true
    this.initData()
  },
  computed: {
    menu() {
      return [
        { title: 'Undo', icon: 'undo', disabled: !this.can_undo, hotkey: this.isMacLike ? 'command+z' : 'ctrl+z', click: () => this.undo() },
        { title: 'Redo', icon: 'redo', disabled: !this.can_redo, hotkey: this.isMacLike ? 'shift+command+z' : 'ctrl+y', click: () => this.redo() },
        { is: 'spacer' },
        { icon: 'format_align_left', title: 'Align left', active: this.isLeftAligned, disabled: !this.current_text_style, hotkey: this.isMacLike ? 'shift+command+l' : 'ctrl+shift+l', click: () => document.execCommand('justifyLeft') },
        { icon: 'format_align_center', title: 'Align center', active: this.isCentered, disabled: !this.current_text_style, hotkey: this.isMacLike ? 'shift+command+e' : 'ctrl+shift+e', click: () => document.execCommand('justifyCenter') },
        { icon: 'format_align_right', title: 'Align right', active: this.isRightAligned, disabled: !this.current_text_style, hotkey: this.isMacLike ? 'shift+command+r' : 'ctrl+shift+r', click: () => document.execCommand('justifyRight') },
        { icon: 'format_align_justify', title: 'Justify content', active: this.isJustified, disabled: !this.current_text_style, hotkey: this.isMacLike ? 'shift+command+j' : 'ctrl+shift+j', click: () => document.execCommand('justifyFull') },
        { is: 'separator' },
        { icon: 'format_bold', title: 'Bold', active: this.isBold, disabled: !this.current_text_style, hotkey: this.isMacLike ? 'command+b' : 'ctrl+b', click: () => document.execCommand('bold') },
        { icon: 'format_italic', title: 'Italic', active: this.isItalic, disabled: !this.current_text_style, hotkey: this.isMacLike ? 'command+i' : 'ctrl+i', click: () => document.execCommand('italic') },
        { icon: 'format_underline', title: 'Underline', active: this.isUnderline, disabled: !this.current_text_style, hotkey: this.isMacLike ? 'command+u' : 'ctrl+u', click: () => document.execCommand('underline') },
        { icon: 'format_strikethrough', title: 'Strike through', active: this.isStrikeThrough, disabled: !this.current_text_style, click: () => document.execCommand('strikethrough') },
        { is: 'button-color', type: 'compact', menu_class: 'align-center', disabled: !this.current_text_style, color: this.curColor, update_color: (new_color) => document.execCommand('foreColor', false, new_color.hex8) },
        { is: 'separator' },
        { icon: 'format_list_numbered', title: 'Numbered list', active: this.isNumberedList, disabled: !this.current_text_style, click: () => document.execCommand('insertOrderedList') },
        { icon: 'format_list_bulleted', title: 'Bulleted list', active: this.isBulletedList, disabled: !this.current_text_style, click: () => document.execCommand('insertUnorderedList') },
        { html: '<b>H1</b>', title: 'Header 1', active: this.isH1, disabled: !this.current_text_style, click: () => document.execCommand('formatBlock', false, '<h1>') },
        { html: '<b>H2</b>', title: 'Header 2', active: this.isH2, disabled: !this.current_text_style, click: () => document.execCommand('formatBlock', false, '<h2>') },
        { html: '<b>H3</b>', title: 'Header 3', active: this.isH3, disabled: !this.current_text_style, click: () => document.execCommand('formatBlock', false, '<h3>') },
        { icon: 'format_clear', title: 'Clear format', disabled: !this.current_text_style, click() { document.execCommand('removeFormat'); document.execCommand('formatBlock', false, '<div>') } },
        { icon: 'splitscreen', title: 'Page break', disabled: !this.current_text_style, click: () => this.insertPageBreak() },
        { is: 'spacer' },
        {
          text: Math.floor(this.zoom * 100) + '%',
          title: 'Zoom',
          icon: 'zoom_in',
          chevron: true,
          menu: [['200%', 2.0], ['150%', 1.5], ['125%', 1.25], ['100%', 1.0], ['75%', 0.75], ['50%', 0.5], ['25%', 0.25]].map(([text, zoom]) => ({
            text,
            active: this.zoom == zoom,
            click: () => { this.zoom = zoom }
          })),
          menu_width: 80,
          menu_height: 280,
          menu_class: 'align-center'
        }
      ]
    },
    current_text_style() { return this.mounted ? this.$refs.editor.current_text_style : false },
    isLeftAligned() { return ['start', 'left', '-moz-left'].includes(this.current_text_style.textAlign) },
    isRightAligned() { return ['end', 'right', '-moz-right'].includes(this.current_text_style.textAlign) },
    isCentered() { return ['center', '-moz-center'].includes(this.current_text_style.textAlign) },
    isJustified() { return ['justify', 'justify-all'].includes(this.current_text_style.textAlign) },
    isBold() {
      const fontWeight = this.current_text_style.fontWeight
      return fontWeight && (parseInt(fontWeight) > 400 || fontWeight.indexOf('bold') == 0)
    },
    isItalic() { return this.current_text_style.fontStyle == 'italic' },
    isUnderline() {
      const stack = this.current_text_style.textDecorationStack
      return stack && stack.some(d => d.indexOf('underline') == 0)
    },
    isStrikeThrough() {
      const stack = this.current_text_style.textDecorationStack
      return stack && stack.some(d => d.indexOf('line-through') == 0)
    },
    isNumberedList() { return this.current_text_style.isList && this.current_text_style.listStyleType == 'decimal' },
    isBulletedList() { return this.current_text_style.isList && ['disc', 'circle'].includes(this.current_text_style.listStyleType) },
    isH1() { return this.current_text_style.headerLevel == 1 },
    isH2() { return this.current_text_style.headerLevel == 2 },
    isH3() { return this.current_text_style.headerLevel == 3 },
    curColor() { return this.current_text_style.color || 'transparent' },
    isMacLike: () => /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform),
    can_undo() { return this.undo_count > 0 },
    can_redo() { return this.content_history.length - this.undo_count - 1 > 0 }
  },
  methods: {
    async initData() {
      let ddaTemplateApiRes, ddaCategoryApiRes
      ;[ddaTemplateApiRes, ddaCategoryApiRes] = await Promise.all([
        DdaTemplateApi.list({ limit: 1000, fields: 'id,name,dda_category_id,content' }),
        DdaCategoryApi.list({ limit: 100, fields: 'id,name,code' }),
      ])
      this.dataDefault.listTemplates = ddaTemplateApiRes.result
      this.dataDefault.listCategories = ddaCategoryApiRes.result
    },
    onCancelForm() {
      localStorage.removeItem(STORAGE_KEY)
      this.$router.push({
        name: 'Admin-ElectronicDocument-create',
        query: { type: this.$route.query.type || 'DOC_SIGN' }
      }).catch(() => {})
    },
    async onCompleteDraf() {
      let data = this.dataForm
      data.html = this.contentChange[0] ? this.contentChange[0] : this.content[0]
      data.status = 'COMPLETED'
      let res
      try {
        res = await DraffDocumentAutoApi.create(data)
      } catch (error) {
        toastr.error('Tạo văn bản thất bại')
        return
      }

      if (res.result) {
        try {
          const ddaId = res.result
          await EmployeeSignatureApi.ExportHtmlToPdf(ddaId)
          localStorage.removeItem(STORAGE_KEY)

          const ddaRes = await DraffDocumentAutoApi.findById(ddaId)
          const fileId = ddaRes.result ? ddaRes.result.unsigned_pdf_id : null

          toastr.success('Tạo văn bản thành công')

          if (fileId) {
            this.$router.push({
              name: 'Admin-ElectronicDocument-create',
              query: {
                fromDetail: fileId,
                doc_name: this.dataForm.name,
                doc_type: 'pdf',
                type: this.$route.query.type || 'DOC_SIGN'
              }
            }).catch(() => {})
          } else {
            this.$router.push({
              name: 'Admin-ElectronicDocument-create',
              query: { type: this.$route.query.type || 'DOC_SIGN' }
            }).catch(() => {})
          }
        } catch (error) {
          toastr.error(error.detail || 'Kết xuất văn bản lỗi')
        }
      } else {
        toastr.error('Tạo văn bản thất bại')
      }
    },
    changeDataContent(dataContent) {
      this.contentChange = dataContent
    },
    overlay(page, total) {
      return '<div style="position: absolute; bottom: 8mm; ' + ((page % 2) ? 'right' : 'left') + ': 10mm">Page ' + page + ' of ' + total + '</div>'
    },
    insertPageBreak() {
      this.$refs.editor.insertPageBreak()
    },
    undo() {
      if (this.can_undo) {
        this.undo_count--
        this.content = [this.content_history[this.undo_count]]
      }
    },
    redo() {
      if (this.can_redo) {
        this.undo_count++
        this.content = [this.content_history[this.undo_count]]
      }
    },
  },
  watch: {
    content(value) {
      if (this.content_history[this.undo_count] == value[0]) return
      this.content_history = this.content_history.slice(0, this.undo_count + 1)
      this.content_history.push(value[0])
      this.undo_count++
    }
  }
}
</script>

<style lang="scss" scoped>
.document-editor {
  height: calc(100vh - 200px);
  overflow: auto;
}
.button-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding: 0 10px;
}
</style>
